import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'

const routes = [
  // ----- Core commerce -----
  { path: '/', name: 'Home', component: () => import('../views/Home.vue'), meta: { public: true } },
  // Single-SKU launch: the product IS the home page. Redirect old listing/detail URLs home.
  { path: '/products', redirect: '/' },
  { path: '/products/:id', redirect: '/' },
  { path: '/cart', name: 'Cart', component: () => import('../views/Cart.vue'), meta: { public: true } },
  { path: '/checkout', name: 'Checkout', component: () => import('../views/Checkout.vue'), meta: { public: true } },
  {
    path: '/order-confirmation/:orderNumber',
    name: 'OrderConfirmation',
    component: () => import('../views/OrderConfirmation.vue'),
    meta: { public: true }
  },

  // ----- Auth -----
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue'), meta: { public: true } },
  { path: '/register', name: 'Register', component: () => import('../views/Register.vue'), meta: { public: true } },
  { path: '/forgot-password', name: 'ForgotPassword', component: () => import('../views/ForgotPassword.vue'), meta: { public: true } },
  { path: '/mfa', name: 'MFA', component: () => import('../views/MFA.vue'), meta: { public: true } },

  // ----- Legal & info pages (stubbed for now; ticket #6 fills these in) -----
  // We resolve to NotFound until those pages are built — better than redirecting silently
  // to home, since users clicking footer "Terms" expect either the page or a clear miss.

  // ----- 404 catch-all (proper NotFound, not the old login-redirect) -----
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { public: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
  if (to.meta.public) return next()
  if (!token) return next({ name: 'Login', query: { redirect: to.fullPath } })
  next()
})

export default router
